import { ContactShadows } from '@react-three/drei';
import { ModelLoad } from 'componentsForThree/ModelLoad';
import { TreeOne } from './tree1';
type Props = {
  pos?: Array<number>;
  rot?: Array<number>;
};
export default function Trees({ pos = [0, 0, 0], rot = [0, 0, 0] }: Props) {
  return (
    <group
      name='trees'
      position={[pos[0], pos[1], pos[2]]}
      scale={[0.4, 0.4, 0.4]}
      rotation={[rot[0], rot[1], rot[2]]}
    >
      <ModelLoad pos={[0, 1.2, 0]} url='assets/model/trees/tree1.glb' />
      <ModelLoad pos={[0.7, 1.2, 0.9]} url='assets/model/trees/tree2.glb' />
      <ModelLoad pos={[1.2, 1.2, 0]} url='assets/model/trees/tree3.glb' />
    </group>
  );
}
